XA.component.navigationMain = (function ($, document) {
    var api = {};
    api.initInstance = function () {
        var navigationIconToggle = $('.navigation-mobile-toggle');
        var navigationMain = $('.component .navigation-main');

        $(navigationIconToggle).on('click', function(){
            $(navigationMain).slideToggle();
            $(navigationMain).toggleClass('show-navigation');
        });

        

        function showSubmenu(){
            
            //submenu
            var submenu = $('.navigation.navigation-main .submenu');
            var submenuTitle = $('.navigation.navigation-main .submenu > .navigation-title a');

            if(submenu.length > 0){
                if ($(window).width() < '1025') {
                    var submenuToggle = '<span class="submenu-toggle-icon" tabindex="0" aria-label="Open submenu"><i class="fa fa-plus" aria-hidden="true"></i></span>'
                    submenuTitle.after(submenuToggle);
  
                    $('.submenu-toggle-icon').on('keypress click', function(e){
                        if (e.which === 13 || e.type === 'click') {
                            let iconParent = $(this).closest('.submenu');

                            if(iconParent.hasClass('show-submenu')){
                                iconParent.removeClass('show-submenu');
                                $(this).attr('aria-label', 'Open submenu');
                                $(this).html('<i class="fa fa-plus" aria-hidden="true"></i>');
                            }else{
                                iconParent.addClass('show-submenu').siblings().removeClass('show-submenu');
                                $(this).attr('aria-label', 'Close submenu');
                                iconParent.siblings().find('.submenu-toggle-icon').attr('aria-label', 'Open submenu');
                                iconParent.siblings().find('.submenu-toggle-icon').html('<i class="fa fa-plus" aria-hidden="true"></i>');
                                $(this).html('<i class="fa fa-minus" aria-hidden="true"></i>');
                            }
                        }
                    });
                }else{
                    $('.submenu-toggle-icon').remove();
                }

            }
            
        };

        showSubmenu();

        $(window).resize(function () {
            showSubmenu();
        });

    };
    api.init = function () {
        api.initInstance();
    };
    return api;
})(jQuery, document);
XA.register("navigationMain", XA.component.navigationMain);